import { Outlet } from "react-router-dom";

export default function InventoryFlowLayout() {
  return <Outlet />;
}
